import React, { useRef, useState } from 'react';
import './FormContacts.scss';
import './FormContacts-media.scss';
import Input from '../Input/Input';
import InputPhone from '../Input/InputPhone';
import Button from '../Button/Button';
import { ServiceData } from '../../redux/services/ServiceRedux';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import ErrorText from '../ErrorText/ErrorText';
import { ValidationFormItems } from '../../services/GlobalFunctions';
import { Props } from './interfaces';
import { CSSTransition } from 'react-transition-group';
import SuccessContent from '../SuccessContent/SuccessContent';
import {content} from "../../services/content";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import AgreementCheckboxes from "../AgreementCheckboxes/AgreementCheckboxes"; // Import the new component

const FormContacts = ({
  blockedSend,
  blockedSendLoaded,
  eventMetrika,
  recaptchaV2ref,
  contactForms,
  title = content.formContacts.title,
  buttonText = content.formContacts.button
}: Props) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('+7');
  const [successShow, setSuccessShow] = useState(false);
  const [errorPhone, setErrorPhone] = useState<string | null>(null);
  const [serverText, setServerText] = useState<string | null>(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);
  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false); // New state
  const [allowMarketing, setAllowMarketing] = useState(false); // New state

  const success = () => {
    setName('');
    setPhone('+7');
    setSuccessShow(true);
    if (typeof ym !== 'undefined') {
      ym(26501373, 'reachGoal', 'feedback_success');
    }
    setTimeout(() => setSuccessShow(false), 3000);
    setDisableBtn(false);
    setPrivacyPolicyAccepted(false);
    setAllowMarketing(false);
  };

  const { executeRecaptcha } = useGoogleReCaptcha(); // v3

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();
    setDisableBtn(true);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    // v3
    let token = '';
    if (!executeRecaptcha) {
      console.debug('recaptcha not set, ignoring');
    } else {
      token = await executeRecaptcha(); // v3
    }

    if (!ValidationFormItems({ phone, setErrorPhone })) {
      setDisableBtn(false);
      return;
    }
    ServiceData.submitForm({
      data: {
        name,
        phone,
        title,
        allowMarketing: allowMarketing // Add marketing consent
      },
      token,
      setServerText,
      success,
      blockedSendLoaded,
      eventMetrika,
      contactFormId: contactForms.main_contact_form_id
    });
  };

  const nodeRefSuccess = useRef(null);
  const nodeRef = useRef(null);

  return (
    <div className="form-contacts">
      <CSSTransition
        in={successShow}
        nodeRef={nodeRefSuccess}
        timeout={{ appear: 200, enter: 0, exit: 200 }}
        classNames="css-transition-modal"
        unmountOnExit
      >
        <SuccessContent refCss={nodeRefSuccess} />
      </CSSTransition>

      <CSSTransition
        in={!successShow}
        nodeRef={nodeRef}
        timeout={{ appear: 200, enter: 0, exit: 0 }}
        classNames="css-transition-content"
        unmountOnExit
      >
        <div className="form-contacts__block">
          <h2 className="form-contacts__title">{title}</h2>
          <ol className="form-contacts__steps">
            {content.formContacts.steps.map((txt: string, index: number) => <li key={index} className="form-contacts__step">{txt}</li>)}
          </ol>

          <form className="form-contacts__form" onSubmit={handleReCaptchaVerify}>
            <Input
              label={content.formContacts.inputName}
              name="name"
              value={name}
              onChange={(e: any) => setName(e.target.value)}
              error={null}
            />
            <InputPhone
              label={content.formContacts.inputPhone}
              name="phone"
              value={phone}
              onChange={(e: any) => setPhone(e.target.value)}
              error={errorPhone}
            />

            <AgreementCheckboxes // Add the component here
              privacyChecked={privacyPolicyAccepted}
              onPrivacyChange={setPrivacyPolicyAccepted}
              marketingChecked={allowMarketing}
              onMarketingChange={setAllowMarketing}
            />

            <div className="form-contacts__button">
              {serverText ? ErrorText(serverText, true) : null}
              <Button text={buttonText} widthAll disabled={disableBtn || !privacyPolicyAccepted} showBlockedError={showBlockedError} />
            </div>
          </form>
        </div>
      </CSSTransition>
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(FormContacts));
